import * as Sentry from "@sentry/react";
import log from "./log";

function setupMonitoring() {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  log.debug("botbrains.monitoring.init");
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT,

    // Filter out dynamic import errors that are not actionable
    ignoreErrors: [
      // catch any "Failed to fetch dynamically imported module" (with or without URL)
      /^Failed to fetch dynamically imported module/,
      // catch any "error loading dynamically imported module"
      /^error loading dynamically imported module/,
      // catch any "Importing a module script failed" (with browser details)
      /^Importing a module script failed/,
      /captured as promise rejection/,
      // ignore AbortError from interrupted media play() requests
      /^AbortError: The play\(\) request was interrupted by a call to pause\(\)/,
      // ignore generic AbortError operations
      /^AbortError: The operation was aborted/,
      // ignore missing raty function errors from judge.me widget
      /\.raty is not a function/,
    ],

    integrations: [
      // https://docs.sentry.io/platforms/javascript/configuration/filtering/
      Sentry.thirdPartyErrorFilterIntegration({
        // Specify the application keys that you specified in the Sentry bundler plugin
        filterKeys: [
          "botbrains-loader-9b90e943-bb1b-471c-8666-71deac6f8578",
          "botbrains-standalone-9b90e943-bb1b-471c-8666-71deac6f8578",
        ],

        // Defines how to handle errors that contain third party stack frames.
        // Possible values are:
        // - 'drop-error-if-contains-third-party-frames'
        // - 'drop-error-if-exclusively-contains-third-party-frames'
        // - 'apply-tag-if-contains-third-party-frames'
        // - 'apply-tag-if-exclusively-contains-third-party-frames'
        behaviour: "drop-error-if-contains-third-party-frames",
      }),
      Sentry.browserTracingIntegration(),
      // Sentry.replayIntegration(),
    ],

    // Performance Monitoring
    tracesSampleRate: 0.001,

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/(staging\.api|api)\.botbrains\.io/,
    ],
    beforeBreadcrumb(breadcrumb, hint) {
      try {
        if (breadcrumb.category === "xhr" || breadcrumb.category === "fetch") {
          const { url } = breadcrumb.data || {};
          const hostname = new URL(url).hostname;
          if (
            [
              "staging.api.botbrains.io",
              "api.botbrains.io",
              "localhost",
            ].includes(hostname)
          ) {
            let headers;
            if (breadcrumb.category === "xhr") {
              headers = hint?.xhr?.__sentry_xhr__.headers;
            } else if (breadcrumb.category === "fetch") {
              headers = hint?.response.headers;
            }
            if (typeof headers === "object") {
              breadcrumb.data = {
                ...breadcrumb.data,
                x_user_id: headers.get("x-user-id"),
                x_request_id: headers.get("x-request-id"),
                x_request_logs: headers.get("x-request-logs"),
              };
            }
          }
        }
      } catch (e) {
        log.debug("Failed to add request headers to breadcrumb", e);
        log.debug(breadcrumb);
      }
      return breadcrumb;
    },

    // Session Replay
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
  });
}

export { setupMonitoring };
